export default {
  'serialRedemption.title': '序號兌換',
  'serialRedemption.heading': '請輸入序號',
  'serialRedemption.instruction': '輸入完畢請按「領取」按鈕',
  'serialRedemption.codeLabel': '序號',
  'serialRedemption.codePlaceholder': '請輸入序號',
  'serialRedemption.codeHint': '請輸入 1 至 32 碼英文字母或數字',
  'serialRedemption.submit': '領取',
  'serialRedemption.successReward': '兌換成功，您已獲得「{name}」',
  'serialRedemption.successPoint': '兌換成功，已存入 {quantity} 點',
  'serialRedemption.successGift': '兌換成功，禮包已存入票券夾',
  'serialRedemption.goToCouponWallet': '前往票券夾',
  'serialRedemption.goToPointCard': '前往點數頁',
  'serialRedemption.goToPointRecords': '前往點數紀錄',
  'serialRedemption.confirm': '確定',
  'serialRedemption.error.SR-001': '序號不存在，請確認後重新輸入。',
  'serialRedemption.error.SR-002': '此序號已被領取，無法重複使用',
  'serialRedemption.error.alreadyRedeemedByMember':
    '您已兌換過此序號，獎勵已發送至您的帳戶',
  'serialRedemption.error.SR-003': '此序號已過期，無法領取。',
  'serialRedemption.error.SR-004': '此優惠目前無法兌換，請聯繫客服。',
  'serialRedemption.error.SR-005': '您已達本兌換專案的兌換上限。',
  'serialRedemption.error.SR-006': '獎勵發放失敗，請稍後再試',
  'serialRedemption.error.SR-007': '此優惠尚未開始，請於活動開始後再領取。',
  'serialRedemption.error.SR-008': '請先登入會員再領取。',
  'serialRedemption.error.SR-010': '此優惠目前無法兌換，請聯繫客服。',
  'serialRedemption.error.SR-011': '此優惠目前無法兌換，請聯繫客服。',
  'serialRedemption.error.rateLimited': '嘗試次數過多，請稍後再試',
  'serialRedemption.error.unknown': '系統忙碌中，請稍後再試',
} as Record<string, string>;
